<template>
  <el-drawer :title="'回访记录：' + workOrderCode" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthSpecial">
    <el-card style="padding: 0 16px 20px !important">
      <el-table ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column type="index" width="50" label="序号" align="center" />
        <el-table-column label="回访备注" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column label="回访人" align="center" width="180">
          <template slot-scope="scope">{{ scope.row.returnViewStaffName || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作时间" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.returnViewTime || '-' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
  </el-drawer>
</template>

<script>
import { worksheetReturnViewPage, worksheetReturnViewCount } from '@/api/workOrder'
export default {
  inject: ['indexThis'],
  data() {
    return {
      workOrderCode: '',
      drawer: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  methods: {
    async worksheetReturnViewPage(params = {}) {
      const { data: res } = await worksheetReturnViewPage({
        ...this.page,
        ...params,
      })
      this.tableData = res || []

      const { data: total } = await worksheetReturnViewCount({
        ...params,
        ...this.queryData,
      })
      this.total = parseInt(total)
    },
    currentChange() {
      this.worksheetReturnViewPage()
    },
  },
}
</script>
